import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { LocalService, PageKey, Wrappers3 } from '../../../service/local.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["gallery", "table"]; source: Wrappers3;
  maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Gallery);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.configurationManagementService.getGalleries(this.source ? this.source.paging : null).subscribe(result => {
      this.source = result;    
    });
  }

  onActiveInactiveStatus(key) {

  }
}
